export default "__VITE_ASSET__2Hngvh2h__"